import { api } from '@/axios/instance/api';

export const fetchOfferByCandidateId = (id) => api.get(`offers/get-offer-by-candidate-id/${id}`);
export const postCurrentOffer = (payload) => api.post(`offers/post_current_offer`, payload);
export const apiResubmitOffer = (payload) => api.post(`offers/${payload.id}/resubmit_offer`, payload);
export const apiSubmitOffer = (payload) => api.patch(`offers/${payload.id}/submit_offer`, payload);
